// extracted by mini-css-extract-plugin
export var name = "SideNavigation-module--name--9c36a";
export var nowrap = "SideNavigation-module--nowrap--5f45a";
export var title = "SideNavigation-module--title--9503e";